import { Stack } from '../../atoms/Stack';
import { Text } from '../../atoms/Text';

export interface DetailFieldProps {
  label: string;
  value?: string | number | null;
}

/** Labelled read-only value row; renders nothing when the value is empty. */
export function DetailField({ label, value }: DetailFieldProps) {
  if (value == null || value === '') return null;
  return (
    <Stack gap={2}>
      <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
        {label}
      </Text>
      <Text size="sm">{value}</Text>
    </Stack>
  );
}
